const SCOPE = 'expression-editor';

export const ExpressionEditorTestIds = {
  VISUAL_MODE_BUTTON: `${SCOPE}.visual-mode-button`,
  ADVANCED_MODE_BUTTON: `${SCOPE}.advanced-mode-button`,
};
